var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcindividual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#26c3c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 33V30.9704C31.5 29.7281 30.9407 28.5099 29.8103 27.9946C28.4315 27.3661 26.7779 27 25 27C23.2221 27 21.5685 27.3661 20.1897 27.9946C19.0593 28.5099 18.5 29.7281 18.5 30.9704V33",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24C26.933 24 28.5 22.433 28.5 20.5C28.5 18.567 26.933 17 25 17C23.067 17 21.5 18.567 21.5 20.5C21.5 22.433 23.067 24 25 24Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcindividual);
export default __webpack_public_path__ + "static/media/icindividual.dcbaeb5f91aeaad89619271ccd88a498.svg";
export { ForwardRef as ReactComponent };